import { render, staticRenderFns } from "./ProgramReport.vue?vue&type=template&id=c0480c1c&"
import script from "./ProgramReport.vue?vue&type=script&lang=js&"
export * from "./ProgramReport.vue?vue&type=script&lang=js&"
import style0 from "./ProgramReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports